import { Card, Flex, Icon, Text } from '@driftt/dds'
import { faClock } from '@driftt/dds.icons/regular/faClock'
import { faClockRotateLeft } from '@driftt/dds.icons/regular/faClockRotateLeft'
import React from 'react'

import { formatTime } from 'utils/moment'

interface HistoryCardProps {
  historyId: string
  datetime: string
  replyGuideline: string
  createdByName: string
  handleClick: () => void
  selectedCardId: string
}

export const HistoryCard = ({
  historyId,
  datetime,
  replyGuideline,
  createdByName,
  handleClick,
  selectedCardId,
}: HistoryCardProps) => {
  const isSelected = historyId === selectedCardId

  return (
    <Card
      key={historyId}
      rootProps={{
        onClick: handleClick,
      }}
      css={{
        borderRadius: '3px',
        padding: '$2',
        gap: '$1',
        marginBottom: '$1',
        width: '100%',
        boxShadow: 'none',
        border: isSelected ? '1px solid $blue8' : '1px solid $gray3',
        '&:hover': {
          backgroundColor: isSelected ? '$blue2' : '$blue1',
          border: '1px solid $blue8',
          cursor: 'pointer',
        },
      }}
    >
      <Card.Header>
        <Card.Title>
          <Flex
            direction="row"
            alignItems="center"
            justifyContent="space-between"
          >
            <Flex direction="row" alignItems="center" gap="half">
              <Icon icon={faClockRotateLeft} css={{ color: '$gray7' }} />
              <Text variant="subtitle2" css={{ color: '$gray7' }}>
                {formatTime(datetime, 'MMM D, YYYY')}
              </Text>
            </Flex>
            <Flex direction="row" alignItems="center" gap="half">
              <Icon icon={faClock} css={{ color: '$gray7' }} />
              <Text variant="subtitle2" css={{ color: '$gray7' }}>
                {formatTime(datetime, 'hh:mm A')}
              </Text>
            </Flex>
          </Flex>
        </Card.Title>
      </Card.Header>

      <Card.Content>
        <Text variant="body" css={{ color: '$gray12', marginBottom: '$1' }}>
          {replyGuideline}
        </Text>
        {isSelected && createdByName && (
          <Text variant="subtitle2" css={{ color: '$gray7' }}>
            Used by {createdByName}
          </Text>
        )}
      </Card.Content>
    </Card>
  )
}
